import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';


class FlightReportLogsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      flight_report_logs: {},
    };

    this.locale = getLocale();
  }
  // Handlers

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.flight_report_logs) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        flight_report_logs: newProps.flight_report_logs,
        loaded: 1,
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <div>
    <h3 className="page-title">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloLogDoRelatorio}</h3>
    <hr/>
    <div className="table-responsive">
      <table className="table table-bordered table-hover table-striped">
        <thead>
          <tr>
            <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaLogRelatorio.Usuario}</th>
            <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaLogRelatorio.Acao}</th>
            <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaLogRelatorio.Descricao}</th>
            <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaLogRelatorio.Data}</th>
          </tr>
        </thead>
        <tbody>
        {Object.keys(self.state.flight_report_logs).map(function(k) {
          var srl = self.state.flight_report_logs[k];
          return (
            <tr>
              <td>{srl.user_name}</td>
              <td>{srl.action}</td>
              <td>{srl.message}</td>
              <td>{srl.created_at_str}</td>
            </tr>
          );
        })}
        </tbody>
      </table>
    </div>
  </div>
</div>
    );
  }
}

export default FlightReportLogsTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Elements/FlightReportLogsTab.js